import React, { useState } from 'react';

import Sidebar from '../Sidebar/Sidebar';
import BillingHeader from '../Billing/BillingHeader';

interface Props {
  desktop: boolean;
  page: string;
  children: any;
}

function BillingWindow(props: Props) {
  const [sidebar, setSidebar] = useState(false);

  if (props.desktop) {
    return (
      <div style={{ width: '100%' }}>
        <BillingHeader desktop={props.desktop} page={props.page} />
        {props.children}
      </div>
    );
  }

  return (
    <>
      <div className="sidenav" style={{ width: sidebar ? '250px' : '0px' }}>
        <Sidebar page="billing" mobile={true} />
      </div>
      <div
        className="mobile-window"
        id="main"
        style={{
          width: '100%',
          position: 'absolute',
          transform: sidebar ? 'translate(-250px)' : 'translate(0px)',
          backgroundColor: 'white',
        }}
        onClick={() => (sidebar ? setSidebar(false) : null)}
      >
        <BillingHeader openSidebar={() => setSidebar(true)} page={props.page} />
        {props.children}
      </div>
    </>
  );
}

export default BillingWindow;
